console.log("VIDEO JS");

document.querySelectorAll(".kids-video__wrap").forEach(function(wrap){

  const video = wrap.querySelector(".kids-video__player");
  const play = wrap.querySelector(".kids-video__play");
  const mute = wrap.querySelector(".kids-video__mute");

  if(!video) return;

  play.addEventListener("click", function(e){

  e.preventDefault();
  e.stopPropagation();

  if(video.paused){

    video.play();
    play.textContent = "PAUSE";

  }else{

    video.pause();
    play.textContent = "PLAY";

  }

});

  mute.addEventListener("click", async function(e){

  e.preventDefault();
  e.stopPropagation();

  if(video.muted){

    video.muted = false;
    video.play();
    mute.textContent = "MUTE";

  }else{

    video.muted = true;
    mute.textContent = "UNMUTE";

  }

});

});